export default function sendErrorToBot(title: string, body: string) {
    console.log(title, '\n', body);
}



// WEBPACK FOOTER //
// ./src/lib/sendErrorToBot.ts